// src/seo.ts
var truncateMetaDescription = (description, maxLength = 155) => {
  if (!description) return "";
  const cleanedDescription = description.trim().replace(/\s+/g, " ");
  if (cleanedDescription.length <= maxLength) {
    return cleanedDescription;
  }
  const truncated = cleanedDescription.substring(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(" ");
  if (lastSpaceIndex > maxLength * 0.8) {
    return truncated.substring(0, lastSpaceIndex) + "...";
  }
  return truncated + "...";
};
var optimizeMetaDescription = {
  /** Desktop SEO (155 chars) */
  desktop: (description) => truncateMetaDescription(description, 155),
  /** Mobile SEO (130 chars) */
  mobile: (description) => truncateMetaDescription(description, 130),
  /** Conservative approach (120 chars) */
  conservative: (description) => truncateMetaDescription(description, 120),
  /** Default optimal (155 chars) */
  default: (description) => truncateMetaDescription(description, 155)
};

export {
  truncateMetaDescription,
  optimizeMetaDescription
};
